import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import SmallBubbleSeattle from './SmallBubbleSeattle'
import { loopIndex, dp } from '../../../utils/shared.js';
import _ from 'lodash';

const MENU_WIDTH_PERCENT = 9.20;
const CONTENT_COMPONENT_OFFSET_PERCENT = 36.45;
const MENU_WIDTH_ADJUSTMENT_PERCENT = 25;
const ELEMENTS_PER_GROUP = 5;
const DISTANCE_BETWEEN_BUBBLES_PERCENT = 1.2;
const BUBBLE_DIAMETER_PERCENT = 8.32;
const ARROW_SIZE_PERCENT = 6;

class MenuBubbleSeattle extends Component {
  constructor(props) {
    super(props);
    this._slickRef = null;
    this._previousButtonRef = null;
    this._nextButtonRef = null;
    this._setupRefsTimeout = null;

    this._regionRendered = false;
    this._groups = [];
    this._contentComponentRightOffset = this.props.regionWidth / 100 * CONTENT_COMPONENT_OFFSET_PERCENT;

    this.state = {
      currentGroup: 0,
      items: []
    }
  }

  componentDidMount() {
    if (this.props.items && this.props.items.length > 0) {
      this._groups = this.setupGroups();
      if (this.props.bubbleId !== undefined && this.props.bubbleId !== null) {
        this.renderElements(this._groups, 0, true, this.props.bubbleId);
      } else {
        this.renderElements(this._groups, 0);
      }
    }

    this.setupRefs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps, this.props)) {
      this._groups = this.setupGroups();
      if (this.props.bubbleId !== undefined && this.props.bubbleId !== null) {
        this.renderElements(this._groups, 0, true, this.props.bubbleId);
      } else {
        this.renderElements(this._groups, 0);
      }
    }

    this.setupRefs();
  }

  componentWillUnmount() {
    clearTimeout(this._setupRefsTimeout);
    if (this._nextButtonRef) {
      this._nextButtonRef.removeEventListener('click', this.handleNextClick);      
    }
    
    if (this._previousButtonRef) {
      this._previousButtonRef.removeEventListener('click', this.handlePreviousClick);
    }
  }
  
  setupRefs = () => {
    if (this._nextButtonRef === null || this._previousButtonRef === null) {
      clearTimeout(this._setupRefsTimeout);
      this._setupRefsTimeout = setTimeout(() => {
        this.setupRefs();
      }, 100)
    } else {
      this._nextButtonRef.addEventListener('click', this.handleNextClick);
      this._previousButtonRef.addEventListener('click', this.handlePreviousClick);
    }
  }

  setupGroups = (activeId) => {
    let groups = [];
    let group = [];

    if (this.props.items.length > 0) {

      let items = this.props.items;
      items = _.orderBy(items, "rank", "asc")

      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        item.active = false;
        if (activeId !== undefined && item.id === activeId) {
          item.active = true;
        }

        group.push(item);
        if ((((i % (ELEMENTS_PER_GROUP - 1) === 0) || (i === items.length - 1))) && (i > 0 || items.length === 1)) {
          groups.push(group);
          group = [];
        }
      }
    }

    return groups;
  }

  handlePreviousClick = () => {
    let index = loopIndex(this.state.currentGroup, 0, this._groups.length - 1, "forward");
    this.renderElements(this._groups, index);
  }
  
  handleNextClick = () => {
    let index = loopIndex(this.state.currentGroup, 0, this._groups.length - 1, "backward");
    this.renderElements(this._groups, index);
  }

  handleBubbleClick = (id) => {
    let groups = this.setupGroups(id);
    this.props.click(this.props.itemId, id);
    this.renderElements(groups, this.state.currentGroup);
  }

  renderElements = (groups, index, activateBubble, bubbleId) => {
    let renderedElements = [];
    if (groups.length > 0) {
      let groupQty = groups[index].length;
      let bubbleDiameter = BUBBLE_DIAMETER_PERCENT * this.props.regionWidth / 100;
      let distanceBetweenBubbles = DISTANCE_BETWEEN_BUBBLES_PERCENT * this.props.regionWidth / 100;
      let sumDistanceBetweenBubbles = distanceBetweenBubbles * (groupQty - 1);
      let sumDiameterBubbles = groupQty * bubbleDiameter;
      let firstElementTop = (this.props.regionHeight - sumDistanceBetweenBubbles - sumDiameterBubbles) / 2;
  
      renderedElements = groups[index].map((item, key) => {
        let top = firstElementTop + (distanceBetweenBubbles * key) + (bubbleDiameter * key);
        let left = ((this.props.regionWidth * MENU_WIDTH_PERCENT / 100) - (this.props.regionWidth * BUBBLE_DIAMETER_PERCENT / 100)) / 2;
        
        if (activateBubble) {
          item.active = item.id === bubbleId ? true : false;
        }

        if (item.display_module_type === "User Input") {
          return null;
        }

        return (
          <div key={key}>
            <SmallBubbleSeattle
              id={item.id}
              index={key}
              active={item.active}
              regionWidth={this.props.regionWidth}
              screen={this.props.screen}
              primaryColor={this.props.primaryColor}
              secondaryColor={this.props.secondaryColor}
              handleClick={this.handleBubbleClick}
              top={top}
              left={left}
            >
              {item.name}
            </SmallBubbleSeattle>
          </div>
        )
      });
    }

    this.setState({
      items: renderedElements,
      currentGroup: index
    });
  }

  render() {
    let width = MENU_WIDTH_PERCENT * this.props.regionWidth / 100;
    let left = this.props.regionWidth - (this.props.regionWidth - this._contentComponentRightOffset) - (width * (MENU_WIDTH_ADJUSTMENT_PERCENT / 100));
    let upIcon = dp(this.props.screen, null, { path:"/img/ui/", file_name:"up.png" });
    let downIcon = dp(this.props.screen, null, { path:"/img/ui/", file_name:"down.png" });
    let arrowSize = ARROW_SIZE_PERCENT * this.props.regionWidth / 100;

    return (
      <div style={{ position:"absolute", width:width, height: this.props.regionHeight, top: 0, left: left }}>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.items}>
            {
              this.props.items.length > 5 ?
              <div>
                <img alt="prevbutton" ref={el => this._previousButtonRef = el} src={upIcon} style={{ position:"absolute", width: arrowSize, height: arrowSize, left: ((width - arrowSize) / 2), top: 0 }} />
              </div>
              :null
            }
            {this.state.items}
            {
              this.props.items.length > 5 ?
              <div>
                <img alt="nextbutton" ref={el => this._nextButtonRef = el} src={downIcon} style={{ position:"absolute", width: arrowSize, height: arrowSize, left: ((width - arrowSize) / 2), bottom: 0 }} />
              </div>
              :null
            }
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default MenuBubbleSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/MenuBubbleSeattle.jsx